import { render } from "./AgreeView.vue?vue&type=template&id=124773e3&scoped=true"
import script from "./AgreeView.vue?vue&type=script&lang=js"
export * from "./AgreeView.vue?vue&type=script&lang=js"

import "./AgreeView.vue?vue&type=style&index=0&id=124773e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124773e3"]])

export default __exports__